// extracted by mini-css-extract-plugin
export default {"root":"WizardButtonGroup_root__LG-I-"};